import * as R from 'ramda';
import tracking from 'modules/tracking';

tracking.init(process.env.MIXPANEL_TOKEN);

const nameSpace = R.concat('ChallengesCarousel::');

export const track = (eventName, props) => tracking.track(nameSpace(eventName), props);
